import { Component, OnInit, NgZone } from "@angular/core";
import {
  IonItemSliding,
  NavController,
  NavParams,
  ModalController,
  LoadingController,
  AlertController,
  IonicModule,
} from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { environment } from "src/environments/environment";
import { EncontroNotaPessoaPage } from "../encontro-nota-pessoa/encontro-nota-pessoa.page";
import { EscalaPage } from "../../culto/escala/escala.page";
import { ReposicaoPage } from "../../reposicao/reposicao.page";
import { EventoProvider } from "src/app/services/evento/evento";
import { UserProvider } from "src/app/services/user/user";
import { ServicosInscricaoPage } from "../../servicos-inscricao/servicos-inscricao.page";
import { Browser } from "@capacitor/browser";
import { format } from "date-fns";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { DateFormatPipe } from "src/app/pipes/date-format/date-format";
import { SafeHtmlPipe } from "src/app/pipes/safe-html/safe-html";
import { ImagePipe } from "src/app/pipes/image/image";
import { SemRegistroComponent } from "src/app/components/sem-registro/sem-registro";
import { VideoPlayerComponent } from "src/app/components/video-player/video-player";
import { BarcodeScanningModalComponent } from "src/app/components/barcode-scanning/barcode-scanning";
import { Barcode, BarcodeScanner, LensFacing } from "@capacitor-mlkit/barcode-scanning";
import { NomenclaturaService } from "src/app/services/nomenclatura/nomenclatura";
import { EventoDetalhesInscricaoPage } from "../evento-detalhes-inscricao/evento-detalhes-inscricao.page";
declare var instituicaoConstants: { IS_PWA: boolean };

@Component({
  selector: "app-encontro",
  templateUrl: "./encontro.page.html",
  styleUrls: ["./encontro.page.scss"],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    DateFormatPipe,
    TranslateModule,
    SafeHtmlPipe,
    ImagePipe,
    SemRegistroComponent,
    VideoPlayerComponent,
    SemRegistroComponent,
  ],
})
export class EncontroPage implements OnInit {
  encontro: any = { responsavel: {} };
  isEnsino: boolean = false;
  isAdmin: boolean = false;
  isPWA: boolean = false;
  isInscrito: boolean = false;
  filtro: any = { q: "" };
  filtroInscritos: any = { q: "" };
  pagination: any = { currentPage: 0, pageCount: 0 };
  encarregadoList: any = [];
  layoutAula: any = [];
  atividades: any = [];
  links: any = [];
  tabSelected: any;
  inscritosList: any = [];
  playVideo: boolean = false;
  playingVideo: boolean = false;
  activeItemSliding: IonItemSliding | null = null;
  isCollapsed = true;
  loaded = false;
  isAvulso = false;
  dataValida = false;
  hasConfig: any;
  hasCheckIn = false;
  pessoaReposicao = [];
  statusInscricao: boolean;
  temporizador: any;
  ischeck = false;
  checkInAntecipado: any;
  tipoEvento: any;
  mostrar = false;
  nomenclaturaDesc: string;
  textoCheckin: string;
  quantidadeInscritos: number;
  qtdCheckInRealizado: number;
  exibirDataValidade = 0;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public loadingController: LoadingController,
    public translate: TranslateService,
    public alertCtrl: AlertController,
    public eventoProvider: EventoProvider,
    private readonly ngZone: NgZone,
    public userProvider: UserProvider,
    private nomenclatura: NomenclaturaService,
  ) {
    this.isPWA = instituicaoConstants.IS_PWA;
    this.encontro = this.navParams.get("encontro");
    this.encontro.evento_nome = this.encontro.evento_nome;
    this.isEnsino = this.navParams.get("isEnsino");
    this.isAdmin = this.navParams.get("isAdmin");
    this.isAvulso = this.navParams.get("isAvulso");
    this.checkInAntecipado = this.navParams.get("checkInAntecipado");
    this.tipoEvento = this.navParams.get("tipoEvento");
    this.exibirDataValidade = this.navParams.get("exibirDataValidade");

    this.tipoEvento === "ensino" ? "ensino" : "evento";
    this.nomenclatura.transform(this.tipoEvento).then((data) => (this.nomenclaturaDesc = data));


    if (this.encontro.isAdmin) {
      this.isAdmin = this.encontro.isAdmin;
    }

    if (this.encontro.materia) {
      this.encontro.materia = this.encontro.materia;
    }

    this.tabSelected = "aula";

    if (this.isEnsino) {
      this.loadNotas();

      this.eventoProvider.getLayoutAula(this.encontro.idEnsinoAula, this.encontro.idEvento).subscribe((data) => {
        this.layoutAula = data.layout;
        this.links = data.linksUteis;
      });
    }

    this.eventoProvider.verificaAdmin(this.encontro.id).subscribe((data) => {
      this.isAdmin = data;
      this.init();
    });
    this.validaCheckIn();
  }

  ngOnInit() {}

  validaCheckIn() {
    this.eventoProvider.verificaCheckIn(this.encontro.idEvento, this.encontro.id).subscribe((data) => {
      this.isInscrito = data.isInscrito;
      this.dataValida = data.dataValida;
      this.hasConfig = data.hasConfig;
      this.hasCheckIn = data.hasCheckIn;
      this.statusInscricao = data.statusInscricao;
    });
  }

  init() {
    this.totalCheckin();
    this.loaded = true;
  }

  openAnexo = async (anexo: string) => {
    await Browser.open({ url: environment.DOWNLOAD_URL + "/" + anexo });
  };

  public closeModal() {
    this.modalCtrl.dismiss();
  }

  async openEscala() {
    let data = {
      entidade: "eventoencontro",
      idEntidade: this.encontro.id,
      idEscala: this.encontro.idEscala,
      isEnsino: this.isEnsino,
    };
    const modalPage = await this.modalCtrl.create({ component: EscalaPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data;
    this.loadEncarregados(null);
  }

  onCancel() {
    this.pagination = { currentPage: 0, pageCount: 0 };
  }

  onCancelInscritos() {
    this.inscritosList = [];
    this.pagination = { currentPage: 0, pageCount: 0 };
    this.filtro = { q: "" };
    this.loadInscritos(null);
  }

  onInput() {
    this.loadEncarregados(null);
  }

  onInputInscritos() {
    clearTimeout(this.temporizador);
    this.temporizador = setTimeout(() => {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadInscritos(null);
    }, 500);
  }

  onSegmentChanged(event: any) {
    const value = event.detail?.value;
    this.tabSelected = value === null || value === undefined || value === "" ? this.tabSelected : value;
    if (value == "escala") {
      this.loadEncarregados(null);
    } else if (value == "gerenciar") {
      this.inscritosList = [];
      this.pagination = { currentPage: 0, pageCount: 0 };
      this.loadInscritos(null);
    }
  }

  loadEncarregados(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;
    this.eventoProvider.getEncarregados(this.filtro, this.pagination, this.encontro.id).subscribe((res) => {
      if (!infiniteScroll) {
        this.encarregadoList = [];
      }

      this.encarregadoList = this.encarregadoList.concat(res.encarregados);
      this.pagination = res.pagination;

      if (infiniteScroll) {
        infiniteScroll.target.complete();
      }
    });
  }

  loadInscritos(infiniteScroll: { target: { complete: () => void } } | null) {
    this.pagination.currentPage++;

    this.eventoProvider
      .getPresencas(this.filtroInscritos, this.pagination, this.encontro.idEvento, this.encontro.id)
      .subscribe((res) => {
        this.inscritosList = this.inscritosList.concat(res.inscritos);
        if (this.ischeck && this.inscritosList.length > 0) {
          this.confirmCheck(this.inscritosList[0]);
        }

        this.pagination = res.pagination;

        if (infiniteScroll) {
          infiniteScroll.target.complete();
        } else if (!infiniteScroll && !this.filtroInscritos.q) {
        }
      });
  }

  loadNotas() {
    this.eventoProvider.getNotasEncontro(this.encontro.id).subscribe((data) => {
      this.atividades = data;
    });

    const dataHoje = new Date();
    const dataEncontro = new Date(this.encontro.dataInicio);

    dataHoje.setHours(0, 0, 0, 0);
    dataEncontro.setHours(0, 0, 0, 0);

    const diaAnterior = new Date(dataEncontro);
    diaAnterior.setDate(dataHoje.getDate() - 1);
    this.mostrar = dataEncontro >= diaAnterior;
  }

  play() {
    this.playVideo = true;

    setTimeout(() => (this.playingVideo = true), 4000);
  }

  openLink = async (link: { target: string; url: any }) => {
    if (link.target == "_blank" && !this.isPWA) {
      await Browser.open({ url: link.url });
    } else {
      await Browser.open({ url: link.url });
    }
  };

  openOption(itemSlide: any, item: any, participante: any) {
    if (this.isEnsino) {
      if (this.activeItemSliding) {
        return this.closeOption();
      }

      this.activeItemSliding = itemSlide;
      const swipeAmount = 104;
      itemSlide.startSliding(swipeAmount);
      itemSlide.moveSliding(swipeAmount);
      itemSlide.setElementClass("active-options-right", true);
      itemSlide.setElementClass("active-swipe-right", true);
      item.setElementStyle("transition", null);
      item.setElementStyle("transform", "translate3d(-" + swipeAmount + "px, 0px, 0px)");
    }
  }

  closeOption() {
    if (this.activeItemSliding) {
      this.activeItemSliding.close();
      this.activeItemSliding = null;
    }
  }

  async notas(participante: any) {
    let data = { idEncontro: this.encontro.id, participante: participante, encontro: this.encontro };
    const modalPage = await this.modalCtrl.create({ component: EncontroNotaPessoaPage, componentProps: data });
    modalPage.present();

    (await modalPage.onDidDismiss()).data;
    this.inscritosList = [];
    this.pagination = { currentPage: 0, pageCount: 0 };
    this.loadInscritos(null);
  }

  async changeCheck(participante: any) {
    const currentDate = new Date()
    const dateInicio = new Date(this.encontro.dataInicio);

    if (!this.checkInAntecipado && currentDate < dateInicio) {
      const alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Atenção"),
        message: this.translate.instant(
          this.translate.instant("Check-in antecipado desabilitado, verifique as configurações do ") + this.nomenclaturaDesc
        ),
        buttons: [{ text: this.translate.instant("Ok") }],
      });

      await alert.present();
    } else if (this.userProvider.hasConfig(202)) {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Atenção"),
        message: this.translate.instant("Deseja realmente dar Check-in para essa pessoa ?"),
        buttons: [
          {
            text: this.translate.instant("Não"),
            handler: () => {},
          },
          {
            text: this.translate.instant("Sim"),
            handler: () => {
              this.checkin(participante);
            },
          },
        ],
      });
      alert.present();
    } else {
      this.checkin(participante);
    }
  }

  async checkin(participante: {
    presenca: string;
    data_check_in: string;
    idEventoEncontroPresenca: any;
    idEventoInscricao: any;
    statusInscricao: any;
  }) {
    if (await this.hasDesistencia(participante.statusInscricao)) {
      return false;
    }
    if (participante.presenca == "1") {
      participante.presenca = "0";
      participante.data_check_in = "";
    } else {
      participante.presenca = "1";
      participante.data_check_in = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    }

    this.eventoProvider.salvarPresencaParticipante(participante).subscribe(async (data) => {
      participante.idEventoEncontroPresenca = data.id;

      if (this.isAvulso && participante.presenca == "1") {
        let params = {
          idInscricao: participante.idEventoInscricao,
          idPresenca: participante.idEventoEncontroPresenca,
          isAvulso: this.isAvulso,
        };
        const modalPage = await this.modalCtrl.create({ component: ServicosInscricaoPage, componentProps: params });
        modalPage.present();

        this.totalCheckin();
      }
    });
  }

  async hasDesistencia(statusInscricao: any) {
    if (statusInscricao === "3") {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: this.translate.instant("Atenção"),
        message: this.translate.instant(
          "Não é possível fazer checkin de um usuário desistente. Se deseja reverter a desistência, procure o responsável pelo ensino."
        ),
        buttons: [
          {
            text: this.translate.instant("Fechar"),
            handler: () => {},
          },
        ],
      });

      alert.present();
      return true;
    }

    return false;
  }

  async retirarCheckin(participante: any) {
    if (participante.data_check_out) return;

    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      header: this.translate.instant("Atenção"),
      message: this.translate.instant("Deseja realmente remover o Check-in dessa pessoa ?"),
      buttons: [
        {
          text: this.translate.instant("Não"),
          handler: () => {},
        },
        {
          text: this.translate.instant("Sim"),
          handler: () => {
            this.checkin(participante);
          },
        },
      ],
    });
    alert.present();
  }

  checkOut(
    slidingItem: { close: () => void },
    participante: { saida: string; data_check_out: string; idEventoEncontroPresenca: any },
    index: any
  ) {
    slidingItem.close();
    if (participante.saida == "1") {
      participante.saida = "0";
      participante.data_check_out = "";
    } else {
      participante.saida = "1";
      participante.data_check_out = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    }

    this.eventoProvider.salvarPresencaParticipante(participante).subscribe((data) => {
      participante.idEventoEncontroPresenca = data.id;
    });
  }

  async readMore(descricao: string | string[]) {
    let alert = await this.alertCtrl.create({
      cssClass: "alerta-personalizado",
      mode: "ios",
      message: this.translate.instant(descricao),
      buttons: [
        {
          text: this.translate.instant("Fechar"),
          handler: () => {},
        },
      ],
    });
    alert.present();
  }

  leitor = async () => {
    await this.checkPermission();
    const formats = LensFacing.Back || [];
    const lensFacing = LensFacing.Back;

    const element = await this.modalCtrl.create({
      component: BarcodeScanningModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
      componentProps: {
        formats: formats,
        lensFacing: lensFacing,
        text: "Leitor",
      },
    });
    element.present();

    element.onDidDismiss().then(async (result: any) => {
      const barcode: Barcode | undefined = result.data?.barcode;

      if (barcode?.displayValue) {
        const code = this.tratarCodigoScaneado(barcode?.displayValue);
        if (code) {
          this.filtroInscritos.q = code.C;
          this.ischeck = true;
          this.onInputInscritos();
        } else {
          BarcodeScanner.stopScan();
          const alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Atenção"),
            message: this.translate.instant(
              "Não foi possível abrir a câmera do celular. Valide as permissões do aplicativo"
            ),
            buttons: [
              {
                text: this.translate.instant("Fechar"),
              },
            ],
          });

          alert.present();
        }
      }
    });
  };

  async confirmCheck(participante: any) {
    if (participante.data_check_in && participante.data_check_out) {
      this.ischeck = false;
      return;
    }

    if ((this.hasConfig == '1' && (participante.parcelaAtual >= 1 || participante.status == 1)) || this.hasConfig == '0') {
      var message = this.translate.instant("Encontramos o cadastro, deseja realizar checkin ?");
      if (participante.presenca == '1' && (!participante.saida || participante.saida == '0')) {
        message = this.translate.instant("Encontramos o cadastro, deseja realizar checkout ?");
      }

      const alert = await this.alertCtrl.create({
        header: this.translate.instant("Atenção"),
        message: message,
        buttons: [
          {
            text: this.translate.instant("Não"),
            handler: () => {
              this.ischeck = false;
            },
          },
          {
            text: this.translate.instant("Sim"),
            handler: () => {
              this.ischeck = false;

              if(participante.presenca == '1' && (!participante.saida || participante.saida == '0')) {
                this.checkoutQR(participante);
              } else {
                this.changeCheck(participante);
              }
            },
          },
        ],
      });

      alert.present();
    } else {
      this.ischeck = false;
    }

  }

  async checkoutQR(participante: any) {
    if (participante.saida == "1") {
      participante.saida = "0";
      participante.data_check_out = "";
    } else {
      participante.saida = "1";
      participante.data_check_out = format(new Date(), "yyyy-MM-dd HH:mm:ss");
    }

    this.eventoProvider.salvarPresencaParticipante(participante).subscribe((data) => {
      participante.idEventoEncontroPresenca = data.id;
    });
  }

  tratarCodigoScaneado(code: string) {
    code = code.replace(/'/g, '"');
    var aux = JSON.parse(code);
    if (aux) return aux;
    return code;
  }

  async retirarServicos(participante: { idEventoInscricao: any; idEventoEncontroPresenca: any }) {
    let params = {
      idInscricao: participante.idEventoInscricao,
      idPresenca: participante.idEventoEncontroPresenca,
      isAvulso: this.isAvulso,
    };
    const modalPage = await this.modalCtrl.create({ component: ServicosInscricaoPage, componentProps: params });
    modalPage.present();
  }

  async reposicao() {
    let params = {
      idEncontro: this.encontro.id,
      idEvento: this.encontro.idEvento,
      idModulo: this.encontro.idEnsinoModulo,
      idAula: this.encontro.idEnsinoAula,
      isAvulso: this.isAvulso,
    };
    const modalPage = await this.modalCtrl.create({ component: ReposicaoPage, componentProps: params });
    modalPage.present();
  }

  leitorCheckIn = async () => {
    await this.checkPermission();
    const formats = LensFacing.Back || [];
    const lensFacing = LensFacing.Back;

    const element = await this.modalCtrl.create({
      component: BarcodeScanningModalComponent,
      cssClass: "barcode-scanning-modal",
      showBackdrop: false,
      componentProps: {
        formats: formats,
        lensFacing: lensFacing,
        text: "Buscar Responsável",
      },
    });
    element.present();

    element.onDidDismiss().then(async (result: any) => {
      const barcode: Barcode | undefined = result.data?.barcode;
      if (barcode?.displayValue) {
        const code = this.tratarCodigoScaneado(barcode?.displayValue);
        if (code) {
          this.salvarPresencaCode(code);
        } else {
          BarcodeScanner.stopScan();
          const alert = await this.alertCtrl.create({
            cssClass: "alerta-personalizado",
            mode: "ios",
            header: this.translate.instant("Atenção"),
            message: this.translate.instant(
              "Não foi possível abrir a câmera do celular. Valide as permissões do aplicativo"
            ),
            buttons: [
              {
                text: this.translate.instant("Fechar"),
              },
            ],
          });

          alert.present();
        }
      }
    });
  };

  async checkPermission() {
    BarcodeScanner.checkPermissions().then((result) => {
      if (result.camera != "granted") {
        return;
      }
    });

    BarcodeScanner.removeAllListeners().then(() => {
      BarcodeScanner.addListener("googleBarcodeScannerModuleInstallProgress", (event) => {
        this.ngZone.run(() => {
          const { state, progress } = event;
        });
      });
    });
  }

  totalCheckin() {
    this.eventoProvider.quantidadeCheckin(this.encontro.idEvento, this.encontro.id).subscribe((data) => {
      this.quantidadeInscritos = data.quantidadeInscritos;
      this.qtdCheckInRealizado = data.qtdCheckInRealizado;
      this.textoCheckin =
        this.qtdCheckInRealizado > 1
          ? this.translate.instant('check-ins realizados')
          : this.translate.instant('check-in realizado');
    });
  }

  async salvarPresencaCode(uuid: string) {
    if (await this.hasDesistencia(this.statusInscricao)) {
      return false;
    }

    this.eventoProvider.salvarPresencaCode(uuid, this.encontro.id).subscribe(async (data) => {
      let alert = await this.alertCtrl.create({
        cssClass: "alerta-personalizado",
        mode: "ios",
        header: data.title,
        message: data.message,
        buttons: [
          {
            text: this.translate.instant("Fechar"),
            handler: () => {
              this.validaCheckIn();
            },
          },
        ],
      });

      alert.present();
    });
  }

  async openDetails(participante: any) {
    const modalPage = await this.modalCtrl.create({ 
      component: EventoDetalhesInscricaoPage, 
      componentProps: {
        participante,
      }
    });
    modalPage.present();

    (await modalPage.onDidDismiss()).data;
  }
}